<template>
  <section>
    <div v-show="showFooter" class="footer">
      <span class="material-icons-outlined" style="color: #333;font-size: 3vh">mail</span>
      <a class="contact" href="/contact">Contact</a>
    </div>
    <div style="z-index: 2; position: fixed;top:auto; bottom: 0;width: 100vw;display: block;">
      <button v-show="menu['home']" class="back-to-top bottom-button" @click="goHome">
        <span class="material-icons-outlined">home</span>
      </button>
      <button v-show="menu['analytics']" class="show-achievement bottom-button" @click="goAnalytics">
        <span class="material-icons-outlined">emoji_events</span>
      </button>
      <div style="position: fixed;right: 0;bottom: 0;vertical-align: bottom">
        <transition-group name="list" tag="div">
          <achivement-item :text="toast.text"  :key="toast.id" v-for="toast in toasts" />
        </transition-group>
      </div>
    </div>
  </section>
</template>

<script>
import {AchievementManager} from "./common/achievement/AchievementManager";
import AchivementItem from "./common/achievement/AchivementItem";
import {SoundEffect} from "./common/SoundEffect";
import {getAnalytics, logEvent} from "firebase/analytics";
export default {
  name: "CommonFooter",
  components: {AchivementItem},
  props: {
    menu: {
      type: Object,
    },
    showFooter: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      achieveSE: new SoundEffect('kiran'),
      toasts: []
    }
  },
  created() {
    AchievementManager.getInstance().addCallback(this.onAchieved)
    // setInterval(()=>{
    //   this.onAchieved("aaa")
    // }, 2000)
  },
  methods: {
    goHome() {
      location.href = '/'
    },
    goAnalytics() {
      location.href = '/analytics'
    },
    onAchieved(achievedRecord) {
      const id = Math.random().toString()
      this.add(id, achievedRecord.toString())
      this.achieveSE.play()

      const analytics = getAnalytics()
      logEvent(analytics, 'achieved', { title: achievedRecord.toString() })
    },
    debug() {
      const id = Math.random().toString()
      this.add(id, id)
    },
    add(id, text) {
      const toast = {
        id,
        text
      }
      this.toasts.push(toast)
      setTimeout(() => {
        this.toasts.splice(toast, 1)
      }, 3000)
    }
  }
}
</script>

<style scoped>
.list-leave-active {
  transition: all 1s ease;
}
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.list-item {
  visibility: visible;
  -webkit-animation: fadein 0.5s;
  animation: fadein 0.5s;
}
@-webkit-keyframes fadein {
  from {bottom: 0; opacity: 0;}
  to {bottom: 30px; opacity: 1;}
}

@keyframes fadein {
  from {bottom: 0; opacity: 0;}
  to {bottom: 30px; opacity: 1;}
}
</style>

<style scoped>
.bottom-button {
  bottom: -1.5vh;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  position: fixed;
  width: 17vh;
  height: 17vh;
  background: linear-gradient(200deg,#e74a23,#e9671f,#ec841b,#efa118);
  color: white;
  border: 1vh solid white;
}

.material-icons-outlined {
  vertical-align: middle;
  display: inline;
  font-family: 'Material Icons';
  font-size: 10vh;
  line-height: 1;
  pointer-events: none;
  color: #fff;
}
.back-to-top {
  left: -2.5vh;
  padding: 0 4vh 0 3vh;
  transform: rotate(5deg);
  border-top-right-radius: 50%;
  box-shadow: 0.5vh -0.5vh 2vh rgba(0,0,0,0.3), -0.5vh -0.5vh 2vh rgba(0,0,0,0.1), 0.5vh 0.5vh 2vh rgba(0,0,0,0.1);
}
.show-achievement {
  right: -2.5vh;
  padding: 0 4vh 0 3vh;
  transform: rotate(-5deg);
  border-top-left-radius: 50%;
  box-shadow: 0.5vh -0.5vh 2vh rgba(0,0,0,0.3), -0.5vh -0.5vh 2vh rgba(0,0,0,0.1), 0.5vh 0.5vh 2vh rgba(0,0,0,0.1);
}

@media (max-aspect-ratio: 1/1) {
  .bottom-button {
    /*bottom: 2.5vh;*/
    bottom: -1.5vh;
    width: 12vh;
    height: 12vh;
  }
  .back-to-top {
    padding: 0 0 0 0.6vh;
  }
  .show-achievement {
    /*right: 0;*/
    padding: 0 0 0.9vh 0;
  }
  .material-icons-outlined {
    font-size: 5vh;
  }
}

.footer {
  width: 100vw;
  background: #eee;
  margin-top: 5vh;
  padding: 3vh 0 3vh 0;
  text-align: center;
  /*position: absolute;*/
  /*bottom: 0;*/
}
.contact {
  /*text-decoration: none;*/
  color: #555;
}
</style>



// WEBPACK FOOTER //
// src/components/CommonFooter.vue